import {
  setDetailSector,
  setFlightCII,
  setSector,
  setSelectedRadar
} from '../slice/emissionSlice';
import {baseQueryWithReAuth} from './config';
import {IFlightCII} from '@/types/radar';
import {ISectorCII} from '@/types/sector';
import {transformAirline} from '@/utils/flight';
import {createApi} from '@reduxjs/toolkit/query/react';
import {toast} from 'react-toastify';

export const ciiApi = createApi({
  reducerPath: 'ciiApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['cii-calc'],
  endpoints: (builder) => ({
    getFlightCII: builder.query<
      IFlightCII,
      {
        flightNumber: string;
        airline: string;
        dateString: string;
        ciType: string;
        currentTrackData: any | null;
        aircraft: string;
        milesToRun: number | null;
        speed: number | null;
        departure: string;
        destination: string;
      }
    >({
      query: ({
        flightNumber,
        airline,
        dateString,
        ciType,
        currentTrackData,
        aircraft,
        milesToRun,
        speed,
        departure,
        destination
      }) => ({
        url: '/ATLAS_cii__get_flight_cii',
        body: {
          airline: transformAirline(airline),
          flight_number: flightNumber,
          date_string: dateString,
          ci_type: ciType,
          current_track_data: currentTrackData,
          aircraft,
          miles_to_run: milesToRun,
          speed,
          departure,
          destination
        },
        method: 'POST'
      }),
      async onQueryStarted(_args, {dispatch, queryFulfilled}) {
        try {
          const data = await queryFulfilled;
          if (data) {
            dispatch(setFlightCII(data?.data));
          }
        } catch (error) {
          void toast.error('Error getting flight CII');
          dispatch(setSelectedRadar(null));
          throw new Error('Error getFlightCII');
        }
      }
    }),

    getSectorCII: builder.query<
      ISectorCII,
      {
        sector: string;
      }
    >({
      query: ({sector}) => ({
        url: '/ATLAS_cii__get_sector_cii',
        body: {
          sector
        },
        method: 'POST'
      }),
      async onQueryStarted(_args, {dispatch, queryFulfilled}) {
        try {
          const data = await queryFulfilled;
          if (data) {
            dispatch(setDetailSector(data?.data));
          }
        } catch (error) {
          void toast.error('Error getting sector CII');
          dispatch(setSector(null));
          throw new Error('Error getSectorCII');
        }
      }
    })
  })
});

export const {useLazyGetFlightCIIQuery, useLazyGetSectorCIIQuery} = ciiApi;
